var _path, _path2, _circle, _path3, _circle2, _path4, _circle3, _path5, _circle4, _path6, _circle5, _path7, _circle6, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3072",
    "data-name": "Grupo 3072",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.423,
    height: 16.508,
    viewBox: "0 0 12.423 16.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2226",
    "data-name": "Caminho 2226",
    d: "M16.707,3.795H14.766a.409.409,0,0,0-.413.466.4.4,0,0,0,.413.4h1.508v13.07H5.583V4.657H6.936a.4.4,0,0,0,.413-.4.409.409,0,0,0-.413-.466H5.15a.436.436,0,0,0-.433.431V18.158a.436.436,0,0,0,.433.431H16.707a.436.436,0,0,0,.433-.431V4.226A.437.437,0,0,0,16.707,3.795Z",
    transform: "translate(-4.717 -2.081)",
    fill: "#64c2c8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2227",
    "data-name": "Caminho 2227",
    d: "M8.092,2.927V14.486a.209.209,0,0,0,.033.108.212.212,0,0,0,.18.108h8.973a.2.2,0,0,0,.136-.053l.014-.011.011-.014a.2.2,0,0,0,.053-.137V2.927a.216.216,0,0,0-.214-.215H16V1.635a.216.216,0,0,0-.214-.215H15.01C14.831.454,13.711.014,12.819,0a2.12,2.12,0,0,0-2.19,1.419H9.863a.216.216,0,0,0-.214.215V2.712H8.306A.216.216,0,0,0,8.092,2.927ZM10.077,1.85h.712a.222.222,0,0,0,.041,0h3.977a.218.218,0,0,0,.041,0h.721V3.608H10.078Q10.077,2.73,10.077,1.85Zm-1.558,4.8v-3.5H9.65v.681a.216.216,0,0,0,.214.215h5.919a.192.192,0,0,0,.135-.053l.015-.011.01-.014A.2.2,0,0,0,16,3.824V3.143h1.068V14.27H8.519Z",
    transform: "translate(-6.567 0)",
    fill: "#64c2c8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_191",
    "data-name": "Elipse 191",
    cx: 0.374,
    cy: 0.374,
    r: 0.374,
    transform: "translate(2.899 4.918)",
    fill: "#64c2c8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2228",
    "data-name": "Caminho 2228",
    d: "M14.96,12.383h4.066a.113.113,0,0,0,0-.226H14.96A.113.113,0,0,0,14.96,12.383Z",
    transform: "translate(-10.557 -6.896)",
    fill: "#64c2c8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_192",
    "data-name": "Elipse 192",
    cx: 0.374,
    cy: 0.374,
    r: 0.374,
    transform: "translate(2.899 6.214)",
    fill: "#64c2c8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2229",
    "data-name": "Caminho 2229",
    d: "M14.96,15.383h4.066a.113.113,0,0,0,0-.226H14.96A.113.113,0,0,0,14.96,15.383Z",
    transform: "translate(-10.557 -8.598)",
    fill: "#64c2c8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_193",
    "data-name": "Elipse 193",
    cx: 0.374,
    cy: 0.374,
    r: 0.374,
    transform: "translate(2.899 7.511)",
    fill: "#64c2c8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2230",
    "data-name": "Caminho 2230",
    d: "M14.96,18.383h4.066a.113.113,0,0,0,0-.226H14.96A.113.113,0,0,0,14.96,18.383Z",
    transform: "translate(-10.557 -10.3)",
    fill: "#64c2c8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_194",
    "data-name": "Elipse 194",
    cx: 0.374,
    cy: 0.374,
    r: 0.374,
    transform: "translate(2.899 8.807)",
    fill: "#64c2c8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2231",
    "data-name": "Caminho 2231",
    d: "M14.96,21.383h4.066a.113.113,0,0,0,0-.226H14.96A.113.113,0,0,0,14.96,21.383Z",
    transform: "translate(-10.557 -12.002)",
    fill: "#64c2c8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_195",
    "data-name": "Elipse 195",
    cx: 0.374,
    cy: 0.374,
    r: 0.374,
    transform: "translate(2.899 10.103)",
    fill: "#64c2c8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2232",
    "data-name": "Caminho 2232",
    d: "M14.96,24.383h4.066a.113.113,0,0,0,0-.226H14.96A.113.113,0,0,0,14.96,24.383Z",
    transform: "translate(-10.557 -13.704)",
    fill: "#64c2c8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_196",
    "data-name": "Elipse 196",
    cx: 0.374,
    cy: 0.374,
    r: 0.374,
    transform: "translate(2.899 11.4)",
    fill: "#64c2c8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2233",
    "data-name": "Caminho 2233",
    d: "M14.96,27.383h4.066a.113.113,0,0,0,0-.226H14.96A.113.113,0,0,0,14.96,27.383Z",
    transform: "translate(-10.557 -15.406)",
    fill: "#64c2c8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicos);
export default __webpack_public_path__ + "static/media/servicos.b88c05821305d3f7fa3cc8fd47aa999e.svg";
export { ForwardRef as ReactComponent };